import React from 'react';
import { Toast as PrimeToast } from 'primereact/toast';
import type { IToastProps } from '../../interfaces/IToast';
import styles from './Toast.module.css';

export const Toast = React.forwardRef<PrimeToast, IToastProps>(
  ({ position = 'top-right', className, ...rest }, ref) => {
    return (
      <PrimeToast
        ref={ref}
        position={position}
        className={`${styles.toast} ${className || ''}`}
        {...rest}
      />
    );
  }
);

Toast.displayName = 'Toast';

export default Toast;
